import useTestAndQuesInfo from "./useTestAndQuesInfo";

const TestAndQuesInfo = ({ data, id, mode }) => {
  const { agreeTerms, handleCheckboxChange, startTestHandler } =
    useTestAndQuesInfo({ id, mode, data });
  return (
    <div className="p-10 mt-10 flex flex-col gap-5 border border-gray-300 rounded-lg shadow-md">
      <div className="grid grid-cols-1">
        <div className="grid grid-cols-2 items-center">
          <span className="border border-r-0 p-10 font-bold ">
            Number of Question
          </span>
          <span className="border p-10 ">{data?.NoOfQuestions}</span>
        </div>
        <div className="grid grid-cols-2 items-center">
          <span className="border border-r-0 p-10 font-bold ">Time(mins)</span>
          <span className="border p-10 ">{data?.Time}</span>
        </div>
        <div className="grid grid-cols-2 items-center">
          <span className="border border-r-0 p-10 font-bold ">Total Marks</span>
          <span className="border p-10 ">{data?.TotalMarks}</span>
        </div>
      </div>
      <div className="flex items-center">
        <input
          type="checkbox"
          id="termsCheckbox"
          className="mr-3"
          checked={agreeTerms}
          onChange={handleCheckboxChange}
        />
        <label htmlFor="termsCheckbox" className="text-sm">
          I have read and understood the instruction . All computer and hardware
          allotted to me are in proper working condition. I agree that in case
          of not ___ to the instructions,I shall be able to be debarred from
          this test and/or to disciplinary action, which may include ban from
          future Test/Examinations
        </label>
      </div>
      <div className="flex justify-center items-center mt-10">
        <button
          onClick={startTestHandler}
          className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
        >
          Start Test
        </button>
      </div>
    </div>
  );
};

export default TestAndQuesInfo;
